import React, {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {userSelector} from '@ibibo/user-reducer';
import Modal from '../../../shared/Modal/Modal';
import SelectTnC from './SelectT&C/SelectT&C';

import {
  selectAgrDemoData,
  selectAgrDemoData1,
  selectAgrDemoData2,
  selectAgrDemoData3,
  selectAgrDemoData4,
  selectAgrDemoData5,
} from './SelectT&C/data';

const LoyalityAgreement = () => {
  const dispatch = useDispatch();

  const [selectAgr, setSelectAgr] = useState(false);

  const [pageIndex, setPageIndex] = useState('new-agreement-confirmation-page');

  const handlePageIndexUpdate = value => {
    setPageIndex(value);
  };

  return (
    <>
      {pageIndex == 'select-agreement-page' && (
        <Modal closeModal={() => setSelectAgr(false)}>
          <SelectTnC
            {...selectAgrDemoData}
            handlePageChange={handlePageIndexUpdate}
            pageIndex={pageIndex}
          />
        </Modal>
      )}
      {pageIndex == 'existing-agreement-confirmation-page' && (
        <Modal closeModal={() => setSelectAgr(false)}>
          <SelectTnC
            {...selectAgrDemoData2}
            handlePageChange={handlePageIndexUpdate}
            pageIndex={pageIndex}
          />
        </Modal>
      )}
      {pageIndex == 'new-agreement-confirmation-page' && (
        <Modal closeModal={() => setSelectAgr(false)}>
          <SelectTnC
            {...selectAgrDemoData3}
            handlePageChange={handlePageIndexUpdate}
            pageIndex={pageIndex}
          />
        </Modal>
      )}
      {pageIndex == 'old-agreement-acknowledged-page' && (
        <Modal closeModal={() => setSelectAgr(false)}>
          <SelectTnC
            {...selectAgrDemoData4}
            handlePageChange={handlePageIndexUpdate}
            pageIndex={pageIndex}
          />
        </Modal>
      )}
      {pageIndex == 'new-agreement-acknowledged-page' && (
        <Modal closeModal={() => setSelectAgr(false)}>
          <SelectTnC
            {...selectAgrDemoData5}
            handlePageChange={handlePageIndexUpdate}
            pageIndex={pageIndex}
            showEmail={true}
          />
        </Modal>
      )}
    </>
  );
};

export default LoyalityAgreement;
